import React from 'react';

const FixedLayoutEditorV2Page = React.lazy(() => import('../pages/fixedLayoutEditorV2/FixedLayoutEditorV2Page'));

export const PATH_FIXED_LAYOUT_EDITOR = '/fixedlayout-editor/:id';

const PAGE_FIXED_LAYOUT_EDITOR = {
  component: FixedLayoutEditorV2Page,
  path: PATH_FIXED_LAYOUT_EDITOR,
};

// IMPORTANT: The order in which the pages are added is important
export default [PAGE_FIXED_LAYOUT_EDITOR];
